<div class="p-3 collaboration-edit">
  <form [formGroup]="form" class="flex flex-column gap-3">
    <div class="border-1 surface-border border-round">
      <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
        {{ 'features.user.collaboration.create.title_label' | translate }}&nbsp;<span class="text-danger">*</span>
      </span>
      <div class="p-3">
        <div class="p-fluid p-float-label mb-3" *ngIf="isServiceType()">
          <input pInputText type="text" [value]="getTypeLabel()" [disabled]="true"/>
          <label>{{ 'features.user.collaboration.create.type' | translate }}</label>
        </div>

        <div class="p-fluid p-float-label mb-3">
          <input pInputText type="text" formControlName="title" maxlength="255"/>
          <label>{{ 'features.user.collaboration.create.title_label' | translate }}&nbsp;<span class="text-danger">*</span></label>
        </div>

        <div class="p-fluid p-float-label mb-3">
          <input pInputText type="text" formControlName="shortDescription" maxlength="255"/>
          <label>{{ 'features.user.collaboration.create.description_short' | translate }}</label>
        </div>

        <div class="p-fluid p-float-label collaboration-edit__textarea">
          <textarea pInputTextarea rows="6" [autoResize]="true" formControlName="description" maxlength="10000"></textarea>
          <label>{{ 'features.user.collaboration.create.description_long' | translate }}</label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isServiceType()">
      <div class="border-1 surface-border border-round">
        <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
          {{ 'features.user.collaboration.create.service_summary' | translate }}
        </span>
        <div class="p-3">
          <div class="p-fluid p-float-label collaboration-edit__textarea mb-3">
            <textarea pInputTextarea rows="6" [autoResize]="true" formControlName="serviceSummary" maxlength="5000"></textarea>
            <label>{{ 'features.user.collaboration.create.service_summary' | translate }}</label>
          </div>

          <div class="flex align-items-center gap-2 mb-3">
            <p-checkbox
              [binary]="true"
              formControlName="createHistoryEntryOnApproval"
              inputId="editHistoryOnApproval"
              [disabled]="isHistoryCheckboxLocked()"
            ></p-checkbox>
            <label for="editHistoryOnApproval">
              {{ 'features.user.collaboration.create.history_on_approval' | translate }}
            </label>
          </div>

          <div class="grid">
            <div class="col-12 md:col-6">
              <div class="p-fluid p-float-label">
                <p-calendar appendTo="body" [showIcon]="true" [showTime]="true" dateFormat="yy-mm-dd" formControlName="historyStartDate" inputId="editHistoryStartDate"></p-calendar>
                <label for="editHistoryStartDate">{{ 'shared.modal.modal_service.add_event.hour_from' | translate }}</label>
              </div>
            </div>
            <div class="col-12 md:col-6">
              <div class="p-fluid p-float-label">
                <p-calendar appendTo="body" [showIcon]="true" [showTime]="true" dateFormat="yy-mm-dd" formControlName="historyEndDate" inputId="editHistoryEndDate"></p-calendar>
                <label for="editHistoryEndDate">{{ 'shared.modal.modal_service.add_event.hour_to' | translate }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
